export default __webpack_public_path__ + "static/media/28-460x460.1b2ff4a0.jpeg";